export default __webpack_public_path__ + "static/mapping1-0637bcf4aa4378109796136016033c36.webm";